import { useNavigate } from "react-router-dom";
import { Button } from "../../components/ui/button";
import { ArrowLeft, Home } from "lucide-react";

const WorkspaceNotFoundPage = () => {
  const navigate = useNavigate();
  return (
    <div className="flex min-h-screen items-center justify-center p-8">
      <div className="max-w-md text-center">
        <p className="text-[13px] font-medium text-muted-foreground mb-2">403</p>
        <h1 className="text-2xl font-semibold text-foreground mb-2">No access to this workspace</h1>
        <p className="text-[14px] text-muted-foreground mb-6">
          You don't have permission to view this workspace. If you think this is a mistake, contact your workspace admin.
        </p>
        <div className="flex items-center justify-center gap-2">
          <Button variant="outline" onClick={() => navigate(-1)}>
            <ArrowLeft className="mr-1.5 h-3.5 w-3.5" />
            Go back
          </Button>
          <Button onClick={() => navigate("/workspaces")}>
            <Home className="mr-1.5 h-3.5 w-3.5" />
            Your Workspaces
          </Button>
        </div>
      </div>
    </div>
  );
};

export default WorkspaceNotFoundPage;
